export const API_URL = import.meta.env.VITE_API_URL;
const SAMORDNA_API_URL = import.meta.env.VITE_SAMORDNA_API_URL;

// NEW:
export const AI_SCANNER_URL = import.meta.env.VITE_AI_SCANNER_URL

export function API(resource: string) {
    return API_URL + resource
}

export function SAMORDNA_API(resource: string) {
  return SAMORDNA_API_URL + resource;
}

// NEW:
export function AI_SCANNER(resource: string) {
    return AI_SCANNER_URL + resource
}